import React from 'react'
import styled from 'styled-components'

interface HeaderTitleProps {
  title?: React.ReactNode
  subtitle?: React.ReactNode
  className?: string
}

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1;
  min-width: 0;
`

const Title = styled.h1`
  ${({ theme }) => theme.typography.variants['Button/Button-16-Semibold']}
  color: ${({ theme }) => theme.palette.gray[800]};
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`

const HeaderTitle: React.FC<HeaderTitleProps> = ({ title, className }) => {
  if (!title) return null

  return (
    <TitleContainer className={className}>
      <Title>{title}</Title>
    </TitleContainer>
  )
}

export default HeaderTitle
